import React from "react";
import { AlertDialog, Button, Flex, Text, Heading } from "@radix-ui/themes";

const ConfirmationPopup = ({
  message,
  cancelButton = "Cancel",
  confirmButton = "Confirm",
  onConfirm,
  onCancel,
  title = "Are you sure?",
  open,
  onOpenChange,
}) => {
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Content style={{ maxWidth: 450 }}>
        <AlertDialog.Title>
          <Heading size="4">{title}</Heading>
        </AlertDialog.Title>
        <AlertDialog.Description size="2" mb="4">
          <Text color="gray">{message}</Text>
        </AlertDialog.Description>
        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray" onClick={onCancel}>
              {cancelButton}
            </Button>
          </AlertDialog.Cancel>
          <AlertDialog.Action>
            <Button variant="solid" color="red" onClick={onConfirm}>
              {confirmButton}
            </Button>
          </AlertDialog.Action>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};

export default ConfirmationPopup;
